import HotelStrategyDetailBaseRoute from 'lumen/routes/hotel/strategy/detail-base';
import { TYPE_ID_MEMBERSHIP } from 'lumen/utils/constants/rate-strategy-constants';

export default class HotelStrategyMembershipRoute extends HotelStrategyDetailBaseRoute {
  type = TYPE_ID_MEMBERSHIP;
}
